import client from '@/utils/client';

export const forgotPassword = async (payload: object) => {
  try {
    const response = await client.post(`/auth/request-reset`, {
      ...payload,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
